import { caseInsensitiveCompare } from './helpers';

function normalizeText(value: string | undefined): string {
  return (value ?? '').trim();
}

export function equalTexts(original: string | undefined, updated: string | undefined): boolean {
  return caseInsensitiveCompare(normalizeText(original), normalizeText(updated));
}

export function datesEqual(original: string | undefined, updated: string | undefined): boolean {
  return original === updated;
}

type IdentityFields = {
  firstName?: string;
  lastName?: string;
  birthday?: string;
};

export function hasIdentityFieldsChanged(
  original: IdentityFields,
  updated: IdentityFields,
): boolean {
  return (
    !equalTexts(original.firstName, updated.firstName) ||
    !equalTexts(original.lastName, updated.lastName) ||
    !datesEqual(original.birthday, updated.birthday)
  );
}
